export const getPossessiveForName = (name = 'Someone') => {
    const lastLetter = name[name.length - 1];
    if (lastLetter === 's') {
        return name + '\u0027';
    }
    return name + '\u0027s';
};
